<template>
    <span class="private-gallery-icon-search">
        <icon-component class="fa-camera-retro" :icon="fa_camera_retro()"></icon-component>
        <icon-component class="heart" :icon="fa_heart_bold()"></icon-component>
    </span>
</template>

<script>
import {fa_camera_retro, fa_heart_bold} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";

export default {
    components: {IconComponent},
    methods: {fa_heart_bold, fa_camera_retro}
}
</script>
